import React from 'react';

const Refund = () => {
  return (
    <div style={{ padding: '50px', marginTop: '50px', maxWidth: '900px', lineHeight: 1.7 }}>
      <h1>Refund Policy</h1>
      <p>Last updated: Jul 9, 2026</p>

      <h2>Subscription Refunds</h2>
      <p>
        If you believe you were charged in error, contact us within 7 days of the charge date.
        We review refund requests case by case.
      </p>

      <h2>Non-Refundable Cases</h2>
      <p>
        Partial-period usage, plan downgrades after renewal, and delayed cancellation requests may
        not be eligible for refunds.
      </p>

      <h2>How to Request</h2>
      <p>
        Email us at memeek01@gmail.com with your account email, payment date, and reason for the
        request.
      </p>

      <h2>Processing Time</h2>
      <p>
        Approved refunds are generally processed within 5-10 business days depending on your
        payment provider.
      </p>
    </div>
  );
};

export default Refund;
